@if (tiles().length > 0) {
  <div class="dashboard-tiles" data-testid="dashboard-tiles">
    @for (tile of tiles(); track tile.label) {
      <button class="tile"
              [class.attention]="tile.attention"
              (click)="openTile(tile)"
              [attr.data-testid]="tile.testId">
        <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
        <span class="tile-count" [attr.data-testid]="tile.testId + '-count'">
          @if (tile.count === null) {
            <mat-spinner [diameter]="24"></mat-spinner>
          } @else {
            {{ tile.count }}
          }
        </span>
        <span class="tile-label">{{ tile.label }}</span>
      </button>
    }
  </div>
}
